<template>
  <div id="app">
  <!-- <main-photos/> -->
  <the-header/>
	<main-content/>
	<!-- <router-view></router-view> -->
  <the-footer/>
  </div>
</template>

<script>
// import MainPhotos from '@/components/layout/MainPhotos.vue';
import TheHeader from '@/components/layout/TheHeader.vue';
import TheFooter from '@/components/layout/TheFooter.vue';
import MainContent from '@/components/layout/MainContent.vue';

export default {
  name : 'App',
  components: {
    // MainPhotos,
    TheHeader,
    TheFooter,
    MainContent
  },
  methods:{
     
  },
  created(){
    
  }
};
</script>

<style>

 
</style>
